import Pos from './Pos';

export default Pos;
